// Rodolfo Rivas
// 2017
//*************************************************************//
//                                                             //
//    ╔═╗┌─┐┌┬┐┌─┐┌─┐┌┐┌┌─┐┌┐┌┌┬┐┌─┐  ┬ ┬┌─┐┬ ┬┌─┐┬─┐┬┌─┐      //
//    ║  │ ││││├─┘│ ││││├┤ │││ │ ├┤   │ │└─┐│ │├─┤├┬┘││ │      //
//    ╚═╝└─┘┴ ┴┴  └─┘┘└┘└─┘┘└┘ ┴ └─┘  └─┘└─┘└─┘┴ ┴┴└─┴└─┘      //
//                                                             //
//*************************************************************//


import {Component, OnInit, SimpleChanges} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {UtilConfig} from "../../../../../autenticacion/servicios/UtilConfig";
import {ScrollEvent} from 'ngx-scroll-event';
import {FormControl} from "@angular/forms";
import {ConsumerService} from "../../../../recursos/servicio/consumer.service";
import {WebServices} from "../../../../recursos/modelo/consumerModel/web-services.enum";
import {Ng2DeviceService} from "ng2-device-detector";
import {LayoutService} from "../../../../recursos/servicio/layout.service";
import {Emisor} from "../../../seguridad/emisor/recursos/modelo/emisor";

declare const $: any;

declare var swal: any;

// ITEM QUE SE DEBE MODIFICAR PARA LOS CRUD

@Component({
    moduleId: module.id,
    selector: 'cmp-list-emisorTerceros',
    templateUrl: './view/list-emisorTerceros.component.html',
    styleUrls: ['./css/list-emisorTerceros.component.scss'],
    providers: [ConsumerService]

})

export class ListEmisorTercerosComponent implements OnInit {

//        ╦┌┐┌┬┌┬┐    ┬ ┬  ╔═╗┌─┐┌┐┌┌─┐┌┬┐┬─┐┬ ┬┌─┐┌┬┐┌─┐┬─┐
//        ║││││ │     └┬┘  ║  │ ││││└─┐ │ ├┬┘│ ││   │ │ │├┬┘
//        ╩┘└┘┴ ┴      ┴   ╚═╝└─┘┘└┘└─┘ ┴ ┴└─└─┘└─┘ ┴ └─┘┴└─

    // ITEM DEL CRUD
    origenCRUD = "Emisor";
    // variables de pantalla
    selectedLista = true;
    search = "";
    searchField: FormControl;
    mensaje = "<i class='material-icons'>search</i>REALICE SU BUSQUEDA UTILIZANDO LOS FILTROS";
    loading = false;
    noHayResultados = false;
    // VARIABLES DE SEGURIDAD
    authorities = {
        ROLE_CONF_TERCERO_LISTAR: true,
        ROLE_CONF_TERCERO_CONSULTAR: true,
        ROLE_CONF_TERCERO_REGISTRAR: true,
    };
    //variables modelo
    ItemLista: any[];
    ItemSelected: Emisor;
    filtro = false;

    // scroll list
    scrollItems: any[] = [];
    readonly bufferSize: number = 20;
    timer: any;
    loadingTexto: boolean = false;
    loadingTextoRefinir: boolean = false;
    totalRegistros = 0;
    init = true;
    emisor: Emisor = new Emisor();
    private colorIcons = null;
    private colorTitle = null;

    constructor(private consumer: ConsumerService,
                private route: ActivatedRoute,
                private layout: LayoutService,
                private router: Router,
                private jwtUtil: UtilConfig,
                private deviceService: Ng2DeviceService) {

        this.emisor = jwtUtil.getCurrentUser().customer;
        // SI LA EMPRESA NO ES ESCON
        if (this.emisor.id != parseInt(jwtUtil.ESCON_CUSTOMER)) {
            this.router.navigate(['/content', {outlets: {'second': ['configThrids', this.emisor.id]}}]);
        }
        this.ItemLista = [];
        // VERIFICA LOS PERMISOS DEL EMISOR LOGEADO
        //this.authorities = jwtUtil.verificarAuthorities(this.authorities);

        if (this.authorities.ROLE_CONF_TERCERO_LISTAR) {
            this.route.params.subscribe(params => {
                if (params['busqueda']) {
                    this.search = params['busqueda'];
                }

                this.realizarBusqueda();
            });
        }
        if (this.jwtUtil.getColorIcons()) {
            this.colorIcons = this.jwtUtil.getColorIcons();
        }
        this.layout.getColorIcons().subscribe(colorIcons => {
            this.colorIcons = colorIcons;
        });
        if (this.jwtUtil.getColorTitle()) {
            this.colorTitle = this.jwtUtil.getColorTitle();
        }
        this.layout.getColorTitle().subscribe(colorTitle => {
            this.colorTitle = colorTitle;
        });
    }

    public handleScroll(event: ScrollEvent) {

        if (event.isReachingBottom) {
            this.fetchMore(event);
        }
        if (event.isWindowEvent) {
            this.fetchMore(event);
            console.log(`This event is fired on Window not on an element.`);
        }

    }

    fetchMore(event) {
        if (this.scrollItems.length != this.ItemLista.length) {
            this.loadingTexto = true;
            this.fetchNextChunk(this.scrollItems.length, this.bufferSize, event).then(chunk => {
                this.scrollItems = this.scrollItems.concat(chunk);
                this.loadingTexto = false;
            }, () => this.loadingTexto = false);
        } else {
            this.loadingTexto = false;
            this.loadingTextoRefinir = true;
        }
    }

    fetchNextChunk(skip: number, limit: number, event?: any): Promise<Emisor[]> {
        return new Promise((resolve, reject) => {
            clearTimeout(this.timer);
            this.timer = setTimeout(() => {
                if (skip < this.ItemLista.length) {
                    return resolve(this.ItemLista.slice(skip, skip + limit));
                }
                reject();
            }, 1000 + Math.random() * 1000);
        });
    }

    ngOnChanges(changes: SimpleChanges) {
        this.reset();
    }

    reset() {
        this.fetchNextChunk(0, this.bufferSize, {}).then(chunk => {
            this.scrollItems = chunk;
            this.loading = false;
        });
    }

    ngOnInit() {


        if (this.deviceService.isMobile() || this.deviceService.isTablet())
            this.selectedLista = false;

        this.searchField = new FormControl();
    }


//        ╔═╗┬ ┬┌┐┌┌─┐┬┌─┐┌┐┌┌─┐┌─┐  ┌─┐┌─┐┌┐┌┌┬┐┌─┐┬  ┬  ┌─┐
//        ╠╣ │ │││││  ││ ││││├┤ └─┐  ├─┘├─┤│││ │ ├─┤│  │  ├─┤
//        ╚  └─┘┘└┘└─┘┴└─┘┘└┘└─┘└─┘  ┴  ┴ ┴┘└┘ ┴ ┴ ┴┴─┘┴─┘┴ ┴       


    eliminar(item) {
        swal({
            title: '¿Está seguro que desea inactivar al emisor? ',
            text: "El emisor: " + item.nombre + ", " + item.ruc,
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Si, Inactivarlo!'
        }).then(() => {
            this.eliminarItem(item);
        }, function (dismiss) {
            // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
            if (dismiss === 'cancel') {
                console.log("CANCEL");
            }
        })
    }

    activar(item) {
        swal({
            title: '¿Está seguro que desea activar al emisor? ',
            text: "El emisor: " + item.nombre + ", " + item.ruc,
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Si, activarlo!'
        }).then(() => {
            this.activarItem(item);

        }, function (dismiss) {
            // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
            if (dismiss === 'cancel') {
                console.log("CANCEL");
            }
        })
    }


    listar() {
        let filtro: any = {};
        if (this.search != "")
            filtro.busqueda = this.search;

        filtro.search = '1';
        this.router.navigate(['/content', {outlets: {'second': ['configThrids', filtro]}}]);
    }


    toggleFiltros() {
        this.filtro = !this.filtro;
    }

//        ╔═╗┬ ┬┌┐┌┌─┐┬┌─┐┌┐┌┌─┐┌─┐  ┌─┐┌─┐┬─┐┬  ┬┬┌─┐┬┌─┐┌─┐
//        ╠╣ │ │││││  ││ ││││├┤ └─┐  └─┐├┤ ├┬┘└┐┌┘││  ││ │└─┐ 
//        ╚  └─┘┘└┘└─┘┴└─┘┘└┘└─┘└─┘  └─┘└─┘┴└─ └┘ ┴└─┘┴└─┘└─┘ 

    eliminarItem(item) {
        // LLAMADO AL SERVICIO
        this.loading = true;
        this.consumer.delete(WebServices.URL_ELIMINAR_EMISOR, {"customer": {id: item.id}})
            .subscribe(result => {
                swal(
                    'Emisor Inactivado!',
                    'La eliminación es lógica, por ende, el emisor sigue existiendo pero inhabilitado',
                    'success'
                );
                item.logEstatusRegistro = "INACTIVO";
                this.loading = false;
            }, err => {
                this.ItemLista = [];
                this.loading = false;
                this.jwtUtil.abrirModalErrorParaServicios(err, "No se pudo inactivar el emisor", this.router)
            });
    }

    activarItem(item) {
        // LLAMADO AL SERVICIO
        this.loading = true;
        this.consumer.activar(WebServices.URL_ACTIVAR_EMISOR, {"customer": {id: item.id}})
            .subscribe(result => {
                swal(
                    'Emisor Activado!',
                    'El emisor sera avisado por un correo!',
                    'success'
                );
                item.logEstatusRegistro = "ACTIVO";
                this.loading = false;
            }, err => {
                this.ItemLista = [];
                this.loading = false;
                this.jwtUtil.abrirModalErrorParaServicios(err, "No se pudo activar el emisor", this.router)
            });
    }

    private realizarBusqueda() {
        // LLAMADO AL SERVICIO

        this.loading = true;
        var param = {}
        this.consumer.get<any>(WebServices.URL_LIST_CUSTOMER_EMISOR_TERCERO)
            .subscribe(result => {
                this.ItemLista = result["thirdReceivers"];
                if (this.ItemLista.length == 0) {
                    this.mensaje = "<i class='material-icons'>youtube_searched_for</i> UTILICE OTRO FILTRO DE BÚSQUEDA SOBRE <b>" + this.origenCRUD.toUpperCase() + "S </b>, NO SE HAN CONSEGUIDO REGISTROS";
                }
                this.totalRegistros = result["rowsCount"];
                if (this.totalRegistros == 0) {
                    this.loading = false;
                } else {
                    this.reset();
                }

            }, err => {
                this.ItemLista = [];
                this.loading = false;
                this.jwtUtil.abrirModalErrorParaServicios(err, "No se pudo obtener la lista de los emisores", this.router)
            });
    }

}



// WEBPACK FOOTER //
// C:/Users/Natalia.Morales/IdeaProjects/datagate/administrator/frontend/src/main/webapp/src/app/layout/content/transaccion/emisorTerceros/cmp-list-emisorTerceros/list-emisorTerceros.component.ts